import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

const DENOMINATIONS = [500000, 200000, 100000, 50000, 20000, 10000, 5000];

export function CashDenominationTable({ values, onChange }) {
  return (
    <>
      <Table size="small" sx={{ '& td, & th': { borderBottom: '1px solid rgba(15,23,42,0.08)' } }}>
        <TableHead>
          <TableRow>
            <TableCell>Denomination</TableCell>
            <TableCell align="right">Quantity</TableCell>
            <TableCell align="right">Line total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {DENOMINATIONS.map((value) => {
            const qty = values[value] ?? 0;
            return (
              <TableRow key={value}>
                <TableCell>
                  <Typography fontWeight={600}>{value.toLocaleString('en-US')} ₫</Typography>
                </TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    size="small"
                    value={qty}
                    onChange={(event) => onChange(value, Number(event.target.value) || 0)}
                    inputProps={{ min: 0, style: { textAlign: 'right' } }}
                  />
                </TableCell>
                <TableCell align="right">{(value * qty).toLocaleString('en-US')} ₫</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
}

CashDenominationTable.defaultProps = {
  values: DENOMINATIONS.reduce((acc, amount) => {
    acc[amount] = 0;
    return acc;
  }, {}),
};

export { DENOMINATIONS };


